export const state = {
    mujeres: [],
    mujer:{}
};

export const mutations = {
    mujer(state, mujer) {
        state.mujer = mujer
    },
    CHANGE_FOLIO(state, folio) {
        state.mujer.folio = folio;
    },
};

export const actions = {
    fecthMujer({ commit }, mujer) {
        commit('mujer', mujer);
    },
    changeFolio({ commit }, { folio }) {
        commit('CHANGE_FOLIO', folio);
    },
};